import { render, staticRenderFns } from "./step2GP96.vue?vue&type=template&id=518cf150&scoped=true"
import script from "./step2GP96.vue?vue&type=script&lang=js"
export * from "./step2GP96.vue?vue&type=script&lang=js"
import style0 from "./step2GP96.vue?vue&type=style&index=0&id=518cf150&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518cf150",
  null
  
)

export default component.exports